import { render, staticRenderFns } from "./PermissionCard.vue?vue&type=template&id=82f9a9b8&"
import script from "./PermissionCard.vue?vue&type=script&lang=js&"
export * from "./PermissionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PermissionCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82f9a9b8')) {
      api.createRecord('82f9a9b8', component.options)
    } else {
      api.reload('82f9a9b8', component.options)
    }
    module.hot.accept("./PermissionCard.vue?vue&type=template&id=82f9a9b8&", function () {
      api.rerender('82f9a9b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ui/PermissionCard.vue"
export default component.exports